import RedirectIcon from '@mui/icons-material/LaunchRounded'
import { IconButton } from '@mui/material'
import * as React from 'react'
import { useRecordContext, useRedirect } from 'react-admin'

const ShowButton = ({ resource }) => {
  const record = useRecordContext()
  const redirect = useRedirect()
  if (!record?.id) {
    return null
  }
  return (
    <IconButton sx={{ color: 'primary.main' }} onClick={() => redirect('show', resource, record.id)} size="large">
      <RedirectIcon />
    </IconButton>
  )
}

export default ShowButton
